import { ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";
import { AccountWithPhoneFormData } from "../../profile.types";

export type Props = {
  /** Form instance from useForm */
  form: UseFormReturn<AccountWithPhoneFormData>;
  /** Handler for form submission */
  onSubmit: () => void;
  /** Handler for cancel/reset */
  onCancel: () => void;
  /** Whether the form has been modified */
  isDirty: boolean;
  /** Whether the form is valid */
  isValid: boolean;
  /** Whether the form is submitting */
  isSubmitting: boolean;

  // Render props - slots each app must fill
  /** Render the form fields */
  renderForm: (props: {
    form: UseFormReturn<AccountWithPhoneFormData>;
  }) => ReactNode;
  /** Render the action buttons */
  renderActions: (props: {
    onSubmit: () => void;
    onCancel: () => void;
    isDirty: boolean;
    isValid: boolean;
    isSubmitting: boolean;
  }) => ReactNode;

  /** Optional className for the container */
  className?: string;
  /** Gap between sections (default: 16px) */
  gap?: string;
};

/**
 * Base account form component.
 * Defines the structure and contract for account/email change forms.
 * Styled implementations should use render props to provide UI.
 */
export function AccountFormBase({
  form,
  onSubmit,
  onCancel,
  isDirty,
  isValid,
  isSubmitting,
  renderForm,
  renderActions,
  className,
  gap = "16px",
}: Props) {
  return (
    <div
      className={className}
      data-testid="account-form"
      style={{ display: "flex", flexDirection: "column", gap }}
    >
      {renderForm({ form })}
      {renderActions({ onSubmit, onCancel, isDirty, isValid, isSubmitting })}
    </div>
  );
}

export default AccountFormBase;

